/*  ==========================================================================
    BOOKING
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initBooking($element) {
    if($('#Bs-BookingWidget').length) {
        window.BsBookingWidget = {
            accommodationId: vars.ts.hgv_booking.id,
            lang: vars.lang,
            onBookingSuccess: function(data) {
                dataLayer.push({
                    'transactionId': "'" + Math.round(new Date().getTime()/1000) + "'",
                    'transactionAffiliation': 'Purchase',
                    'transactionTotal': data.price,
                    'transactionTax': 0,
                    'transactionShipping': 0,
                    'transactionProducts': [{
                        'sku': "'DD" + Math.round(new Date().getTime()/1000) + "'",
                        'name': 'Booking',
                        'category': 'Purchase',
                        'price': data.price,
                        'quantity': 1
                    }]
                });

                dataLayer.push({
                    "event": "BnEventConversion",
                    "eventCategory": "Conversion",
                    "eventAction": "Booking",
                    "eventValue": data.price,
                });
            },
            onRequestSuccess: function(data) {
                dataLayer.push({
                    "event": "BnEventConversion",
                    "eventCategory": "Conversion",
                    "eventAction": "Request"
                });
            }
        };

        let booking_js = {
            src: 'https://widget.bookingsuedtirol.com/widget.js'
        };

        utils.dynFileLoader.load(booking_js, 'js');
    }
}



// WEBPACK FOOTER //
// ./source/js/modules/lib/booking.js